/* Riders Parts — "Shop your ride" (v2, 2026-09-25). Modelled on RevZilla's flow:
 *   Type -> Year -> Make -> Model -> a vehicle page "2019 Yamaha MT-09 Parts & Accessories (N)"
 *   with an Exact fit / Universal fit toggle and a "search parts for this vehicle" box.
 *
 * WHERE THE FITMENT COMES FROM (this is real data, not a text search any more):
 *   - Turn 14's per-row year|make|model fitment, joined to our products by part number
 *     (98.9% make agreement with product titles; the disagreeing 1.1% were left out), and
 *   - the fitment.* metafields for products Turn 14 does not cover.
 *   Each product carries opaque tags (see "fitment tags (v3)" below): a model-year code (exact), or
 *   a model code + year code / any-year. Universal parts (product TITLE says universal) carry
 *   fzuniversal. The vehicle page is Shopify's own search with a tag query, so facets, sort and
 *   paging all work:  (tag:fx<m|y> OR (tag:fm<m> AND (tag:fy<y> OR tag:fyzzzz))) <words>
 *   Universal parts join only with rp_fit=all ("Add universal parts") or rp_fit=universal (2026-11-02).
 *   🚨 v2 used readable tags (fm-kawasaki-z900) and Shopify tokenised them — z900 matched z900rs.
 *   Check any change with bike-filter-fix/verify-pipeline*.mjs against the data, not by eye.
 *
 * The v1 finder searched the bike NAME as text. It returned MT-07 exhausts for an MT-09 and, with a
 * year selected, almost nothing (the year went in as "'12" text). Do not bring that back.
 *
 * Vehicle list: assets/rp-vehicles.json, fetched only when a picker or a vehicle page needs it.
 * Format: { types:{street,dirt,atv}, makes:[..], models:[[makeIdx, name, slug, type, [[from,to],..]]] }
 */
(function () {
  // Several sections each include this file (header panel, finder bar, saved-bike strip, vehicle
  // header). Every <script> element executes even with the same src, so run once per page.
  if (window.RPFitment && window.RPFitment.v === 2) return;
  var KEY = 'rp.garage';
  var POPULAR = ['BMW', 'Ducati', 'Harley-Davidson', 'Honda', 'Kawasaki', 'KTM', 'Suzuki', 'Triumph', 'Yamaha'];
  var CHIPS = ['Exhaust', 'Brakes', 'Suspension', 'Drivetrain', 'Filters', 'Electrical', 'Protection', 'Tires'];
  var TYPE_KEYS = ['street', 'dirt', 'atv'];
  var TYPE_NAMES = { street: 'Street Bike', dirt: 'Dirt Bike', atv: 'UTV/ATV' };

  /* ── vehicle data ─────────────────────────────────────────────────────── */
  var dataPromise = null;
  function dataUrl() {
    var el = document.querySelector('[data-rp-vehicles]');
    if (el) return el.getAttribute('data-rp-vehicles');
    var s = document.querySelector('script[src*="rp-fitment.js"]');
    return s ? s.src.split('?')[0].replace(/rp-fitment\.js$/, 'rp-vehicles.json') : null;
  }
  function loadData() {
    if (!dataPromise) {
      var url = dataUrl();
      dataPromise = url ? fetch(url).then(function (r) { if (!r.ok) throw new Error('vehicles ' + r.status); return r.json(); })
        .then(function (d) {
          d.bySlug = {};
          d.models.forEach(function (m) { d.bySlug[m[2]] = m; });
          return d;
        }) : Promise.reject(new Error('no vehicles url'));
      dataPromise.catch(function () { dataPromise = null; });
    }
    return dataPromise;
  }
  function hasYear(m, y) {
    for (var i = 0; i < m[4].length; i++) if (y >= m[4][i][0] && y <= m[4][i][1]) return true;
    return false;
  }

  /* ── saved bike ───────────────────────────────────────────────────────
     localStorage can throw (Safari private mode, blocked site data): every access is wrapped. */
  function loadBike() {
    try { var b = JSON.parse(window.localStorage.getItem(KEY) || 'null'); return b && b.s && b.y ? b : null; } catch (e) { return null; }
  }
  function saveBike(b) { try { window.localStorage.setItem(KEY, JSON.stringify(b)); } catch (e) {} }
  function clearBike() { try { window.localStorage.removeItem(KEY); } catch (e) {} }
  // v1 stored {year, make, model} under rp.bike with no slug; it cannot be mapped reliably. Drop it.
  try { window.localStorage.removeItem('rp.bike'); } catch (e) {}
  function label(b) { return b ? [b.y, b.mk, b.md].join(' ') : ''; }

  /* ── fitment tags (v3) ──────────────────────────────────────────────────
     Shopify's storefront search matches tag: by TOKENS — it split "fm-kawasaki-z900" on hyphens and
     prefix-matched "z900rs" (27% precision on one bike). So every fitment tag is ONE opaque,
     letters-only, fixed-length token. MUST match bike-filter-fix/build-tags-v3.mjs exactly:
       model fm+code(slug) · model-year fx+code(slug|year) · year fy+letters · any year fyzzzz
       universal fzuniversal · code = two FNV-1a 32-bit hashes as 7 base-26 letters each */
  function h32(s, seed) { var h = seed >>> 0; for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619) >>> 0; } return h >>> 0; }
  function b26(n) { var o = ''; for (var i = 0; i < 7; i++) { o = String.fromCharCode(97 + (n % 26)) + o; n = Math.floor(n / 26); } return o; }
  function code(s) { return b26(h32(s, 2166136261)) + b26(h32(s, 0x9747b28c)); }
  function yl(y) { return String(y).split('').map(function (d) { return String.fromCharCode(97 + +d); }).join(''); }

  /* ── the vehicle page URL ─────────────────────────────────────────────── */
  // Default = exact fit only (Manuel, 2026-11-02: "when someone selects their bike they only get their
  // bike's parts"). Universal parts show only when the shopper asks: fit 'all' (exact + universal) or 'universal'.
  function fitQuery(b, fit) {
    var exact = 'tag:fx' + code(b.s + '|' + b.y) + ' OR (tag:fm' + code(b.s) + ' AND (tag:fy' + yl(b.y) + ' OR tag:fyzzzz))';
    if (fit === 'all') return '(' + exact + ' OR tag:fzuniversal)';
    if (fit === 'universal') return 'tag:fzuniversal';
    return '(' + exact + ')';
  }
  // Typed words. Shopify search IGNORES plain words next to a tag: group (measured 2026-11-02: Panigale V4
  // + "exhaust" returned all 115 parts, Harley mirrors included), but field-scoped terms do filter. So each
  // word must match the title, type, brand, a tag or a SKU (singular or plural). body: is left out on
  // purpose: it matched clamps whose description mentions an exhaust. The bike's own name, its year and
  // filler words are dropped, because the fitment group already covers them.
  var FILLER = ['for', 'the', 'and', 'of', 'to', 'with', 'my', 'a', 'an', 'fits', 'fit', 'fitment', 'part', 'parts'];
  function wordQuery(b, text) {
    var skip = FILLER.concat(b.s.split('-'), [String(b.y)]);
    return (text || '').toLowerCase().split(/[^a-z0-9.\-]+/).filter(function (w) {
      return w && /[a-z0-9]/.test(w) && skip.indexOf(w) < 0;
    }).map(function (w) {
      var f = [w];
      if (/[^s]s$/.test(w) && w.length > 3) f.push(w.slice(0, -1)); else if (/[a-z]$/.test(w) && !/s$/.test(w)) f.push(w + 's');
      return ' AND (' + f.map(function (x) {
        return 'title:' + x + ' OR product_type:' + x + ' OR vendor:' + x + ' OR tag:' + x + ' OR variants.sku:' + x;
      }).join(' OR ') + ')';
    }).join('');
  }
  function vehicleUrl(b, opts) {
    opts = opts || {};
    var q = fitQuery(b, opts.fit) + wordQuery(b, opts.q);
    var u = '/search?type=product&q=' + encodeURIComponent(q) +
      '&rp_v=' + encodeURIComponent(b.s) + '&rp_y=' + b.y + (opts.fit && opts.fit !== 'exact' ? '&rp_fit=' + opts.fit : '') +
      (opts.q ? '&rp_q=' + encodeURIComponent(opts.q) : '');
    if (opts.type) u += '&filter.p.product_type=' + encodeURIComponent(opts.type);
    return u;
  }
  // Recover bike + mode + words from a vehicle-page URL. The tags are opaque hashes, so the bike comes
  // from rp_v / rp_y (renderVehiclePage falls back to the saved bike if a filter link dropped them).
  function parseVehicleUrl(loc) {
    var qs = new URLSearchParams(loc.search);
    var q = qs.get('q') || '';
    var vehicle = /tag:fx[a-z]{14}/.test(q), uni = /tag:fzuniversal/.test(q);
    var fit = vehicle ? (uni ? 'all' : 'exact') : 'universal';
    // words = whatever follows the leading tag expression: a balanced (...) group, or the bare tag
    var words = q;
    if (q.charAt(0) === '(') {
      for (var i = 0, d = 0; i < q.length; i++) { if (q[i] === '(') d++; else if (q[i] === ')' && --d === 0) { words = q.slice(i + 1); break; } }
    } else words = q.replace(/^tag:fzuniversal/, '');
    // the shopper's own words travel in rp_q; if a filter link dropped it, read them back from the title: terms
    if (qs.get('rp_q') != null) words = qs.get('rp_q');
    else if (/ AND \(title:/.test(words)) words = (words.match(/ AND \(title:[^ )]+/g) || []).map(function (s) { return s.slice(12); }).join(' ');
    return { slug: qs.get('rp_v'), year: qs.get('rp_y'), fit: fit, words: words.trim(), type: qs.get('filter.p.product_type') || '' };
  }

  /* ── picker (header panel, finder bar, mobile drawer all use this) ───── */
  function opt(sel, value, text) { var o = document.createElement('option'); o.value = value; o.textContent = text; sel.appendChild(o); return o; }
  function reset(sel, placeholder) { sel.innerHTML = ''; opt(sel, '', placeholder); sel.disabled = true; }

  function mountPicker(root, onDone) {
    if (!root || root.dataset.rpGarageReady) return;
    root.dataset.rpGarageReady = '1';
    var type = root.querySelector('[data-rp-g-type]'), year = root.querySelector('[data-rp-g-year]'),
        make = root.querySelector('[data-rp-g-make]'), model = root.querySelector('[data-rp-g-model]'),
        go = root.querySelector('[data-rp-g-go]');
    if (!type || !year || !make || !model || !go) return;
    var D = null;
    function state() { go.disabled = !(D && type.value && year.value && make.value && model.value); }
    function fillYears() {
      reset(year, 'Year'); reset(make, 'Make'); reset(model, 'Model');
      if (!type.value) return state();
      var ys = {};
      D.models.forEach(function (m) { if (m[3] === type.value) m[4].forEach(function (r) { for (var y = r[0]; y <= r[1]; y++) ys[y] = 1; }); });
      Object.keys(ys).map(Number).sort(function (a, b) { return b - a; }).forEach(function (y) { opt(year, y, y); });
      year.disabled = false; state();
    }
    function fillMakes() {
      reset(make, 'Make'); reset(model, 'Model');
      if (!year.value) return state();
      var y = +year.value, mk = {};
      D.models.forEach(function (m) { if (m[3] === type.value && hasYear(m, y)) mk[D.makes[m[0]]] = 1; });
      var all = Object.keys(mk).sort(function (a, b) { return a.localeCompare(b); });
      var pop = POPULAR.filter(function (p) { return mk[p]; });
      if (pop.length && all.length > 6) {
        var g1 = document.createElement('optgroup'); g1.label = 'Popular makes';
        pop.forEach(function (p) { opt(g1, p, p); }); make.appendChild(g1);
        var g2 = document.createElement('optgroup'); g2.label = 'All makes';
        all.forEach(function (p) { opt(g2, p, p); }); make.appendChild(g2);
      } else all.forEach(function (p) { opt(make, p, p); });
      make.disabled = false; state();
    }
    function fillModels() {
      reset(model, 'Model');
      if (!make.value) return state();
      var y = +year.value;
      D.models.filter(function (m) { return m[3] === type.value && D.makes[m[0]] === make.value && hasYear(m, y); })
        .sort(function (a, b) { return a[1].localeCompare(b[1], undefined, { numeric: true }); })
        .forEach(function (m) { opt(model, m[2], m[1]); });
      model.disabled = false; state();
    }
    var touched = false;
    type.addEventListener('change', function () { touched = true; reset(year, 'Loading…'); ready().then(fillYears).catch(function () { reset(year, 'Year'); }); });
    year.addEventListener('change', fillMakes);
    make.addEventListener('change', fillModels);
    model.addEventListener('change', state);
    go.addEventListener('click', function () {
      if (go.disabled) return;
      var m = D.bySlug[model.value];
      var b = { t: type.value, y: +year.value, mk: make.value, md: m ? m[1] : model.options[model.selectedIndex].text, s: model.value };
      saveBike(b);
      if (onDone) onDone(b);
      window.location.href = vehicleUrl(b);
    });

    // The three types are fixed, so Type works instantly; the 300 KB vehicle list loads in the
    // background the moment someone reaches for the picker, and Year waits on it if it must.
    reset(type, 'Type'); TYPE_KEYS.forEach(function (k) { opt(type, k, TYPE_NAMES[k]); }); type.disabled = false;
    reset(year, 'Year'); reset(make, 'Make'); reset(model, 'Model'); go.disabled = true;
    function ready() {
      if (D) return Promise.resolve();
      return loadData().then(function (d) {
        if (D) return;
        D = d;
        var saved = loadBike();                       // come back to the bike they chose last time
        if (!touched && saved && d.bySlug[saved.s]) {
          type.value = saved.t; fillYears(); year.value = saved.y; fillMakes(); make.value = saved.mk; fillModels(); model.value = saved.s; state();
        }
      });
    }
    ['pointerenter', 'focusin', 'touchstart'].forEach(function (ev) { root.addEventListener(ev, function () { ready().catch(function () {}); }, { once: true, passive: true }); });
    var det = root.closest('details');
    if (det) det.addEventListener('toggle', function () { if (det.open) ready().catch(function () {}); });
    if (root.hasAttribute('data-rp-g-eager')) ready().catch(function () {});
    return ready;
  }

  /* ── header label + "your ride" box ───────────────────────────────────── */
  function renderHeader() {
    var b = loadBike();
    document.querySelectorAll('[data-rp-g-label]').forEach(function (el) {
      if (!el.dataset.rpDefault) el.dataset.rpDefault = el.textContent;
      el.textContent = b ? b.y + ' ' + b.mk + ' ' + b.md : el.dataset.rpDefault;
    });
    document.querySelectorAll('[data-rp-g-sub]').forEach(function (el) {
      if (!el.dataset.rpDefault) el.dataset.rpDefault = el.textContent;
      el.textContent = b ? 'Shop parts for your ride' : el.dataset.rpDefault;
    });
    document.querySelectorAll('[data-rp-g-current]').forEach(function (box) {
      box.hidden = !b;
      if (!b) return;
      var n = box.querySelector('[data-rp-g-current-name]'); if (n) n.textContent = label(b);
      var a = box.querySelector('[data-rp-g-current-go]'); if (a) a.href = vehicleUrl(b);
      var x = box.querySelector('[data-rp-g-current-remove]');
      if (x && !x.dataset.wired) {
        x.dataset.wired = '1';
        x.addEventListener('click', function () { clearBike(); renderHeader(); renderStrip(); });
      }
    });
  }

  /* ── saved-bike strip under the header ────────────────────────────────── */
  function renderStrip() {
    var bar = document.querySelector('[data-rp-mybike]');
    if (!bar) return;
    var b = loadBike();
    if (!b) { bar.hidden = true; return; }
    var name = bar.querySelector('[data-rp-mybike-name]'); if (name) name.textContent = label(b);
    var chips = bar.querySelector('[data-rp-mybike-chips]');
    if (chips) {
      chips.innerHTML = '';
      var all = document.createElement('a');
      all.className = 'rp-mybike__chip rp-mybike__chip--all'; all.href = vehicleUrl(b); all.textContent = 'All parts for this bike';
      chips.appendChild(all);
      CHIPS.forEach(function (t) {
        var a = document.createElement('a');
        a.className = 'rp-mybike__chip';
        // Tyres are chosen by SIZE; no tyre in the catalogue carries bike fitment. Send them to the
        // size finder with a note instead of an empty "no match" page.
        a.href = t === 'Tires' ? '/collections/tires?rp_tirenote=' + encodeURIComponent(label(b)) : vehicleUrl(b, { type: t });
        a.textContent = t;
        chips.appendChild(a);
      });
    }
    var change = bar.querySelector('[data-rp-mybike-change]');
    if (change && !change.dataset.wired) {
      change.dataset.wired = '1';
      change.addEventListener('click', function () {
        var panel = document.querySelector('.rp-util--fitment');
        if (panel) { panel.setAttribute('open', ''); panel.scrollIntoView({ block: 'center' }); }
      });
    }
    bar.hidden = false;
  }

  /* ── the vehicle page (Shopify /search with our tag query) ────────────── */
  function renderVehiclePage() {
    var vh = document.querySelector('[data-rp-vh]');
    if (!vh) return;
    var p = parseVehicleUrl(window.location);
    var saved = loadBike();
    loadData().then(function (D) {
      var m = p.slug ? D.bySlug[p.slug] : null;
      var b = m ? { t: m[3], y: +p.year, mk: D.makes[m[0]], md: m[1], s: m[2] } : saved;
      if (!b) return;
      if (!saved || saved.s !== b.s || saved.y !== b.y) saveBike(b);   // a shared link sets the garage
      renderHeader(); renderStrip();
      var name = label(b);
      vh.querySelectorAll('[data-rp-vh-name]').forEach(function (el) { el.textContent = name; });
      document.title = name + ' Parts & Accessories | Riders Parts Miami';

      // search inside this vehicle
      var form = vh.querySelector('[data-rp-vh-form]'), input = vh.querySelector('[data-rp-vh-input]');
      if (input) input.value = p.words;
      if (form) form.addEventListener('submit', function (e) {
        e.preventDefault();
        window.location.href = vehicleUrl(b, { q: input.value.trim(), fit: p.fit, type: p.type });
      });
      var clear = vh.querySelector('[data-rp-vh-clear]');
      if (clear) { clear.hidden = !p.words; clear.addEventListener('click', function () { window.location.href = vehicleUrl(b, { fit: p.fit, type: p.type }); }); }

      // fitment toggle with counts (Section Rendering API: renders only this small section)
      var sid = vh.getAttribute('data-section-id');
      vh.querySelectorAll('[data-rp-vh-fit]').forEach(function (a) {
        var f = a.getAttribute('data-rp-vh-fit');
        var url = vehicleUrl(b, { q: p.words, fit: f, type: p.type });
        a.href = url;
        a.classList.toggle('is-active', f === p.fit);
        var c = a.querySelector('[data-rp-vh-count]');
        // The chip for the mode on screen uses the page's own count. A separate fetch of the SAME
        // URL can come from a different Shopify page-cache snapshot while the index settles
        // (measured 111 vs 121), and the heading and active chip must never disagree.
        if (c && f === p.fit) { c.textContent = '(' + Number(vh.getAttribute('data-rp-vh-total')).toLocaleString() + ')'; return; }
        if (c && sid) fetch(url + '&section_id=' + encodeURIComponent(sid)).then(function (r) { return r.text(); }).then(function (h) {
          var n = (h.match(/data-rp-vh-total="(\d+)"/) || [])[1];
          if (n != null) c.textContent = '(' + Number(n).toLocaleString() + ')';
        }).catch(function () {});
      });
      var change = vh.querySelector('[data-rp-vh-change]');
      if (change) change.addEventListener('click', function () {
        var panel = document.querySelector('.rp-util--fitment');
        if (panel) { panel.setAttribute('open', ''); panel.scrollIntoView({ block: 'center' }); }
      });

      // tyres: explain instead of pretending
      var tyre = /\btires?\b|\btyres?\b/i.test(p.words) || p.type === 'Tires';
      var note = vh.querySelector('[data-rp-vh-tires]');
      if (note) note.hidden = !tyre;
    }).catch(function () {});
  }

  /* ── /collections/tires arriving from the strip ───────────────────────── */
  function renderTireNote() {
    var bike = new URLSearchParams(window.location.search).get('rp_tirenote');
    if (!bike || document.querySelector('.rp-tirenote')) return;
    var box = document.createElement('div');
    box.className = 'rp-tirenote'; box.setAttribute('role', 'status');
    var s = document.createElement('strong'); s.textContent = 'Tires fit by size, not by bike. ';
    var t = document.createElement('span');
    t.textContent = 'Find the size printed on your current tire’s sidewall (for example 180/55ZR17) and choose it below. Not sure what your ' + bike + ' takes? ';
    var a = document.createElement('a'); a.href = '/pages/contact'; a.textContent = 'Ask us and we’ll check.';
    box.appendChild(s); box.appendChild(t); box.appendChild(a);
    var main = document.querySelector('#MainContent') || document.querySelector('main');
    if (main) main.insertBefore(box, main.firstChild);
  }

  window.RPFitment = {
    v: 2, loadData: loadData, loadBike: loadBike, saveBike: saveBike, clearBike: clearBike,
    label: label, vehicleUrl: vehicleUrl, parseVehicleUrl: parseVehicleUrl, mountPicker: mountPicker,
    renderHeader: renderHeader, renderStrip: renderStrip
  };

  /* The panel is a full-height drawer, but the header is a containing block for position:fixed, so
     inside it the drawer started below the announcement bar and sat under it. While open, the panel
     lives in <body> (with its own backdrop) and goes home again on close. */
  function portal(det) {
    var panel = det.querySelector('.rp-garage');
    if (!panel || det.dataset.rpPortal) return;
    det.dataset.rpPortal = '1';
    var home = panel.parentNode;
    var backdrop = document.createElement('div');
    backdrop.className = 'rp-garage-backdrop';
    backdrop.addEventListener('click', function () { det.open = false; });
    det.addEventListener('toggle', function () {
      if (det.open) {
        document.body.appendChild(backdrop); document.body.appendChild(panel);
        panel.classList.add('is-open');
        var first = panel.querySelector('select:not(:disabled), a, button'); if (first) first.focus({ preventScroll: true });
      } else {
        panel.classList.remove('is-open'); home.appendChild(panel); backdrop.remove();
      }
    });
  }
  function closeAll() { document.querySelectorAll('.rp-util--fitment[open]').forEach(function (d) { d.open = false; }); }

  function boot() {
    document.querySelectorAll('.rp-util--fitment').forEach(portal);
    document.querySelectorAll('[data-rp-garage]').forEach(function (r) { mountPicker(r); });
    renderHeader(); renderStrip(); renderVehiclePage(); renderTireNote();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-rp-fitment-close]')) { closeAll(); return; }
    if (e.target.closest('.rp-garage, .rp-util--fitment')) return;   // clicks inside the drawer or on its toggle
    // buttons elsewhere that OPEN the drawer ("Select different vehicle", "Change bike")
    if (e.target.closest('[data-rp-vh-change], [data-rp-mybike-change]')) return;
    if (e.target.closest('.rp-garage-backdrop')) return;            // handled by the backdrop itself
    closeAll();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
})();
